<template>
  <div>
    <rotaion
      :height="height"
      :route="this.$route.path"
      arrow="never"
      position="none"
    ></rotaion>
    <div class="center-content">
      <div class="main">
        <div class="sub-navbar">
          <h4>公司介绍</h4>
          <span class="icon iconfont icon-down" @click="hideNav"></span>
          <ul class="nav-show">
            <!-- <li @click="toggleVisible" data-index='1' :class="flag == 1?'active-show':''">公司简介</li> -->
            <!-- | -->
            <!-- <li @click="toggleVisible" data-index='3' :class="flag == 3?'active-show':''">成长历程</li> -->
          </ul>
        </div>
        <ul class="nav-collapse" v-if="isHide">
          <!-- <li @click="toggleVisible" data-index='1' :class="[(flag == 1?'active':''),'animated','slideInDown']">公司简介</li> -->
          <!-- <li @click="toggleVisible" data-index='3' :class="[(flag == 3?'active':''),'animated','slideInDown']" style="border-bottom: 0;padding-bottom: 0;">成长历程</li> -->
        </ul>
        <hr />
        <div :class="['content-introduce', flag == 1 ? '' : 'isvisible']">
          <div
            style="display: flex; width: 100%; justify-content: flex-start"
          ></div>
          <p style="margin-top: 30px; text-indent: 1.9rem">
            厦门登游科技是一家自研自发的游戏公司，办公地点设立在美丽的海上明珠——厦门。
            登游科技成立于2018年3月，
            是一家年轻朝气蓬勃的企业，团队成员扎根移动互联网行业多年，
            拥有技术和雄厚的研发实力，
            在产品设计、研发、等方面具有顶尖的行业经验。
            公司主营微信小游戏、QQ小游戏。公司成立一年多来，
            已发行的产品有《搭桥高手》
            《子弹特工》《超级坦克王》《沙漠球球》等300多款小游戏，累计注册用户8亿+，每日在线玩家500多万。
          </p>
        </div>
        <div :class="['content-introduce', flag == 2 ? '' : 'isvisible']">
          <div style="display: flex; width: 100%; justify-content: flex-start">
            <img
              width="150px"
              src="https://game-cdn.feigo.fun/uploads/20211006/79V9M9uz54uyCYF9R0J6e2CgJj5JE4Dx.png"
            />
          </div>
          <p>携手同行，不忘初心</p>
        </div>
        <div :class="['content-introduce', flag == 3 ? '' : 'isvisible']">
          <!-- <Linkage></Linkage> -->
        </div>
        <div class="sub-navbar">
          <!-- <h4>企业文化</h4> -->
        </div>
        <!-- <hr /> -->
        <div class="dny">
          <!-- <DynBanner></DynBanner> -->
        </div>
      </div>
      <bottom></bottom>
    </div>
  </div>
</template>
<script>
import rotaion from "./components/rotation";
import bottom from "./components/bottom";
import DynBanner from "../components/DynBanner/DynBanner.vue";
export default {
  components: {
    rotaion,
    bottom,
    DynBanner,
  },
  data() {
    return {
      flag: 1,
      isHide: false,
      isShow: false,
      height: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("mousewheel", this.getScroll, false);
    if (this.getScrollTop() > 200) {
      this.isShow = true;
    }
  },
  methods: {
    toggleVisible(e) {
      this.flag = e.target.dataset.index;
    },
    hideNav() {
      this.isHide = !this.isHide;
    },
    getScroll(event) {
      if (window.scrollY > 200) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    backTop() {
      let that = this;
      let timer = setInterval(function () {
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop -= 10;
        } else {
          document.body.scrollTop -= 10;
        }
        if (that.getScrollTop() < 200) {
          that.isShow = false;
        }
        if (that.getScrollTop() == 0) {
          clearInterval(timer);
        }
      }, 3);
    },
    getScrollTop() {
      var scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
  },
};
</script>
<style scoped>
.main {
  width: 100%;
  background-color: #ffffff;
}
.sub-navbar {
  width: 60%;
  height: 3rem;
  margin: 0 auto;
  padding: 1.25rem 2.5rem 0;
  display: flex;
  justify-content: space-between;
}
.nav-show {
  width: -webkit-fit-content;
  height: 100%;
  display: flex;
  justify-content: center;
  color: rgba(44, 62, 80, 0.6);
}
.nav-show li {
  list-style: none;
  display: block;
  margin: 0 0.9375rem;
  padding: 0 10px;
  padding-bottom: 2rem;
  cursor: default;
}
li:hover {
  color: rgba(44, 62, 80, 1);
}
.content-introduce {
  width: 40%;
  margin: 20px auto;
  text-align: left;
  padding-bottom: 1rem;
}
.icon-down {
  font-size: 20px;
  display: none;
}
.isvisible {
  display: none;
}
.active-show {
  color: #0086fb;
  border-bottom: 1.5px solid #0086fb;
}
.nav-collapse {
  display: none;
}
.dny {
  width: 56.25rem;
  margin: 0 auto;
}
@media screen and (max-width: 992px) {
  .dny {
    width: 80%;
    margin: 0 auto;
  }
  .sub-navbar {
    width: 90%;
  }
  .content-introduce {
    width: 60%;
    padding-bottom: 3rem;
  }
}
@media screen and (max-width: 672px) {
  .sub-navbar {
    width: 100%;
    padding: 1.25rem 0.9375rem 0;
    margin-bottom: 18px;
  }
  h4 {
    font-size: 18px;
  }
  .content-introduce {
    width: 80%;
    padding-bottom: 0;
  }
  .dny {
    width: 90%;
    margin: 0 auto;
  }
  .icon-down {
    font-size: 20px;
    display: block;
  }
  .nav-show {
    display: none;
  }
  .nav-collapse {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 30px;
    padding: 0 1.25rem;
    color: rgb(136, 136, 136);
    font-size: 0.875rem;
  }
  .nav-collapse li {
    text-align: left;
    margin: 0 auto;
    width: 80%;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid rgba(125, 125, 125, 0.3);
  }
  .active {
    color: #4e90c0;
  }
}
.relocation {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: rgb(204, 204, 204);
  text-align: center;
  position: fixed;
  z-index: 99;
  right: 8rem;
  bottom: 3.75rem;
}
.relocation:hover {
  background: rgb(153, 153, 153);
}
.center-content {
  position: absolute;
  top: 70%;
  z-index: 10000000;
  background-color: #ffffff;
  width: 100%;
}
</style>